<template>
<v-container class="home-page-container" fluid>
<v-layout xs12 class="admin-header">
    <v-flex ml-4>
        <span style="font-size:20px;">Setup and Configure</span>
    </v-flex>
</v-layout>
<v-layout wrap>
    <v-flex xs8>
        <v-container v-bind="{ [`grid-list-xl`]: true }" fluid>
            <v-layout wrap xs12>
                <v-flex v-for="(item, i) in pageMenuItems" :key="i" xs4>
                    <v-card v-if="!item.suOnly" class="panelBackground" @click="navigate(item)" flat style="border: 1px solid #9B9B9B; cursor: pointer; width:140px; height:140px;">
                        <v-card-text style="text-align: center;">
                            <div class="linkIcon">
                                <v-icon size=30 color="var(--default-color)">
                                    {{item.icon}}
                                </v-icon>
                            </div>
                            <div class="caption font-weight-bold" style="color: var(--soft-text-color);">{{item.title}}</div>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-flex>
    <v-flex xs4>
        <v-container v-bind="{ [`grid-list-xl`]: true }" fluid  v-if="isSU">
            <v-layout wrap xs12>
                <v-flex v-for="(item, i) in pageMenuSuItems" :key="i" xs6>
                    <v-card @click="navigate(item)" class="panelBackground" flat style="border: 1px solid #9B9B9B; cursor: pointer; width:140px; height:140px;">
                        <v-card-text style="text-align: center;justify-content:center;">
                            <!-- <template v-if="item.title === 'Metrics'" v-slot:badge>
                                <span>{{metricsInAlarm.length}}</span>
                            </template> -->
                            <div class="linkIcon">
                                <v-icon size=30 color="var(--secondary-btn-color)">{{item.icon}}</v-icon>
                            </div>
                            <div>
                                <span class="caption font-weight-bold" style="color: var(--soft-text-color); margin-bottom:0px;">{{item.title}}</span>
                            </div>
                       </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-flex>
</v-layout>
<v-layout xs12>
    <v-flex ml-4>
        <span class="caption">Ready to start using the product? Go to <a href="/">My WXP Collaboration</a></span>
    </v-flex>
</v-layout>
</v-container>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
export default {
    computed: {
        ...mapGetters('collectors', {
            workerSessions: "getWorkerSessions"
            // collectorsNotFound: 'collectorsNotFound',
            // metricsInAlarm: "getMetricsInAlarm"
        }),
        ...mapGetters('user', {
            isSU: 'isSU',
            justLoggedIn: 'justLoggedIn'
        }),
        ...mapGetters('menus', {
          items: 'getMenu'
        }),
        pageMenuItems: {
            get() {
                return _.sortBy(_.filter(this.items, (item) => {return !item.suOnly && !!item.pageSeq}), ['pageSeq'])
            }
        },
        pageMenuSuItems: {
            get() {
                return _.sortBy(_.filter(this.items, (item) => {return item.suOnly && !!item.pageSeq}), ['pageSeq'])
            }
        }
    },
    methods: {
        navigate(item) {
            window.location.hash = item.url;
        }
    },
    watch: {
        workerSessions: function(val) {
            if (this.justLoggedIn) {
                this.$store.dispatch('user/setJustLoggedIn', false)
                if (!this.workerSessions || !this.workerSessions.length) {
                    this.$router.replace({name: 'gettingStarted'})
                }
            }
        }
    }
}
</script>
<style scoped="true">
  .caption {
    line-height: 1rem;
  }
  .home-page-container {
    .v-card__text {
      padding: 30px 16px;
    }
    .linkIcon {
      margin-bottom: 15px;
    }
    .panelBackground {
      background-color: var(--panel-background);
    }
  }
</style>
